<template>
    <v-app>
        <v-main style="max-height: 100vh; max-width: 100vw">
            <login v-if="!loggedIn"/>
            <main-screen v-else/>
            <snack/>
        </v-main>
  </v-app>
</template>

<script>
import Snack from "./components/Snack/Snack";
import Login from "./components/Login/Login";

import {mapGetters} from "vuex";
import Main from "./components/Main/Main";


export default {
    name: 'App',

    components: {
        MainScreen: Main,
        Login,
        Snack,
    },
    data: () => ({
        //
    }),
    computed: {
        ...mapGetters(['loggedIn'])
    }
};
</script>

<style>



</style>
